import type { RequestInterface } from '~/common/types';

export class TrackingsRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/worker-monitorings';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };

    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}
